const showcase = document.getElementById('showcase') as HTMLIFrameElement;
const key = 'YOUR_KEY_HERE';

// declare this file is a module
export {};

// augment window with the MP_SDK property
declare global {
  interface Window {
    MP_SDK: any;
    dataLayer: any[];
  }
}



showcase.addEventListener('load', async function() {
  let sdk:any;
  try {
    sdk = await showcase.contentWindow.MP_SDK.connect(showcase, key, '3.6');
  }
  catch(e) {
    console.error(e);
    return;
  }

  console.log('%c  Hello Bundle SDK! ', 'background: #333333; color: #00dd00');
  console.log(sdk);


/*ルーム情報*/

sdk.Floor.current.subscribe(function (currentFloor:any) {
  if(currentFloor.name && currentFloor.name != 'all'){
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "event": "floor", 'floorData': currentFloor.name });
  console.log('フロアー情報', currentFloor.name)
  }
});

/*ルーム情報*/

/*定規モード*/
sdk.Measurements.mode.subscribe(function (measurementModeState:any) {
  // 定規モード起動
  if(measurementModeState.active){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "event": "Mode", 'modeData': '定規モード' });
    console.log(window.dataLayer);
  }
  console.log('Is measurement mode currently active? ', measurementModeState.active);
 });
//定規コレクション数
 sdk.Measurements.data.subscribe({
  onCollectionUpdated: function (collection:any) {
    const collectionLength = Object.keys(collection).length;
    if(collectionLength != 0){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "event": "collection", 'collectionData': collectionLength + '箇所測定' });
    console.log(window.dataLayer);
    console.log(collectionLength);
    }
  }
});
/*定規モード*/

/*閲覧モードGA4*/
sdk.on(sdk.App.Event.PHASE_CHANGE,
  function(pose:any) {
    if(pose == 'appphase.playing'){
      sdk.Mode.current.subscribe(function (mode:any) {
        let modeplan;
        if (mode == 'mode.dollhouse' || mode == 'mode.floorplan') {
          if(mode == 'mode.dollhouse'){
            modeplan = 'ドールハウスモード';
          }else if(mode == 'mode.floorplan'){
            modeplan = '平面図モード';
          }
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ "event": "Mode", 'modeData': modeplan });
          console.log(window.dataLayer);
          console.log('現在のモード', modeplan);
        }
      });
    }
  }
);
/*閲覧モードGA4*/

  /*タグデータGA4*/

  let tagsData: any = {};

  sdk.Tag.data.subscribe({
    onCollectionUpdated(collection:any) {
      // 全てのタグデータを保持しておく
      tagsData = collection;
    }
  });
  

  sdk.Tag.openTags.subscribe({
    prevState: {
      hovered: null,
      docked: null,
      selected: null,
    },
    onChanged(newState:any) {
      if (!this.prevState.selected && newState.hovered !== this.prevState.hovered) {
        if (newState.hovered) {
          console.log(newState.hovered, 'ホバー開始');
          let hoveredData = tagsData[newState.hovered];
          window.dataLayer = window.dataLayer || [];
          setTimeout(() => {
            window.dataLayer.push({ "event": "MatterTag", 'hoveredData': hoveredData.label, 'hoveredDataClick': null, 'dockeData': null });
            console.log(window.dataLayer);
            console.log(hoveredData.label);
          }, 0);
        } else {
          console.log(this.prevState.hovered, 'ホバー解除');
        }
        this.prevState.hovered = newState.hovered;
      }

      if (newState.docked !== this.prevState.docked) {
        if (newState.docked) {
          console.log(newState.docked, 'ドックオープン');
          let dockeData = tagsData[newState.docked];
          window.dataLayer = window.dataLayer || [];
          setTimeout(() => {
            window.dataLayer.push({ "event": "MatterTag", 'hoveredData': null, 'hoveredDataClick': null, 'dockeData': dockeData.label });
            console.log(window.dataLayer);
            console.log(dockeData.label);
          }, 0);
        } else {
          console.log(this.prevState.docked, 'ドッククローズ');
        }
      }
  
      const [selected = null] = newState.selected;
      if (selected !== this.prevState.selected) {
        if (selected) {
          console.log(selected, 'クリック選択開始');
          let selectedData = tagsData[selected];
          window.dataLayer = window.dataLayer || [];
          setTimeout(() => {
            window.dataLayer.push({ "event": "MatterTag", 'hoveredData': null, 'hoveredDataClick': selectedData.label, 'dockeData': null });
            console.log(window.dataLayer);
            console.log(selectedData.label);
          }, 0);
        } else {
          console.log(this.prevState.selected, 'クリック選択解除');
        }
        this.prevState.selected = selected;
      }
  
      this.prevState.docked = newState.docked;
    },  
  });
  /*タグ GA4*/
  




});